
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {
   1: { // Exercise num
      unit: 'Unit 2',
      id: 'WB3-U2-P19-E1',
      audio: '',
      video: '',
      component: D1,
      checkUppercase: true,
      titleImage: '',
      exerciseKey: 'img/FriendsPlus/Page19/E1/Key/answerKey.png',
      question: [
      ],
      questionImage: [
         [
            // Column1
            { url: 'img/FriendsPlus/Page19/E1/1.jpg' },
         ],
         [
            // Column2
            { url: 'img/FriendsPlus/Page19/E1/2.jpg' },
            { url: 'img/FriendsPlus/Page19/E1/3.jpg', input: true, answer: "Anh's teacher is Miss Tam." },
            { url: 'img/FriendsPlus/Page19/E1/4.jpg' },
         ],
         [
            // Column3
            { url: 'img/FriendsPlus/Page19/E1/5.jpg' },
         ],
         [
            // Column4
            { url: 'img/FriendsPlus/Page19/E1/6.jpg' },
            { url: 'img/FriendsPlus/Page19/E1/7.jpg', input: true, answer: "His name's Trung." },
            { url: 'img/FriendsPlus/Page19/E1/8.jpg' },
         ],
         [
            // Column5
            { url: 'img/FriendsPlus/Page19/E1/9.jpg' },
         ],
         [
            // Column6
            { url: 'img/FriendsPlus/Page19/E1/10.jpg' },
            { url: 'img/FriendsPlus/Page19/E1/11.jpg', input: true, answer: "Mai is Trung's cousin." },
            { url: 'img/FriendsPlus/Page19/E1/12.jpg' },
         ],
         [
            // Column7
            { url: 'img/FriendsPlus/Page19/E1/13.jpg' },
         ],
         [
            // Column8
            { url: 'img/FriendsPlus/Page19/E1/14.jpg' },
            { url: 'img/FriendsPlus/Page19/E1/15.jpg', input: true, answer: "Vinh is her little brother." },
            { url: 'img/FriendsPlus/Page19/E1/16.jpg' },
         ],

      ]
   },
   2: { // Exercise num
      unit: 'Unit 2',
      id: 'WB3-U2-P19-E2',
      audio: '',
      video: '',
      component: UI,
      titleImage: '',
      question: [
      ],
      questionImage: [
         [
            // Column1
            { url: 'img/FriendsPlus/Page19/E2/1.jpg' },
         ],
         [
            { url: 'img/FriendsPlus/Page19/E2/2.jpg' },
         ],
      ]
   },
   3: { // Exercise num
      unit: 'Unit 2',
      id: 'WB3-U2-P19-E3',
      audio: '',
      video: '',
      component: D1,
      hideBtnFooter: true,
      titleImage: '',
      exerciseKey: 'img/FriendsPlus/Page19/E1/Key/answerKey.png',
      question: [
      ],
      questionImage: [
         [
            // Column1
            { url: 'img/FriendsPlus/Page19/E3/1.jpg' },
         ],
         [
            // Column2
            { url: 'img/FriendsPlus/Page19/E3/2.jpg' },
         ],
         [
            // Column3
            { url: 'img/FriendsPlus/Page19/E3/3.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/4.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/5.jpg' },
         ],
         [
            // Column4
            { url: 'img/FriendsPlus/Page19/E3/6.jpg' },
         ],
         [
            // Column5
            { url: 'img/FriendsPlus/Page19/E3/7.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/8.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/9.jpg' },
         ],
         [
            // Column6
            { url: 'img/FriendsPlus/Page19/E3/10.jpg' },
         ],
         [
            // Column7
            { url: 'img/FriendsPlus/Page19/E3/11.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/12.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/13.jpg' },
         ],
         [
            // Column8
            { url: 'img/FriendsPlus/Page19/E3/14.jpg' },
         ],
         [
            // Column9
            { url: 'img/FriendsPlus/Page19/E3/15.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/16.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/17.jpg' },
         ],
         [
            // Column10
            { url: 'img/FriendsPlus/Page19/E3/18.jpg' },
         ],
         [
            // Column11
            { url: 'img/FriendsPlus/Page19/E3/19.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/20.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/21.jpg' },
         ],
         [
            // Column12
            { url: 'img/FriendsPlus/Page19/E3/22.jpg' },
         ],
         [
            // Column13
            { url: 'img/FriendsPlus/Page19/E3/23.jpg' },
            { url: 'img/FriendsPlus/Page19/E3/24.jpg', input: true, answer: "" },
            { url: 'img/FriendsPlus/Page19/E3/25.jpg' },
         ],
         [
            // Column14
            { url: 'img/FriendsPlus/Page19/E3/26.jpg' },
         ],



      ]
   },

}

export default json;